import React from "react";
import { useSelector } from "react-redux";
import AreaChart from "../../../../../components/areaChart/areaChart";

export const YearOverYearChart = () => {
  const areaChart = useSelector((state) => state.attritionAndCancelReasons.areaChart);
  if (!areaChart) return null;

  return (
    <div className="section__el area-chart">
      <AreaChart
        chartData={areaChart}
        width={675}
        currencySymbol="%"
        currentDataKey="current"
        previousDataKey="previous"
      />
    </div>
  );
};
